var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * 组件数据请求方法
 *
 */
import axios from 'axios';
import { getCookie } from './env';
import { getQueryParam } from './url';
import { currentTraceId } from './uuid';
// 后端接口地址
export const BackEndUrl = 'https://ai.tu.qq.com/trpc.shadow_cv.ai_processor_cgi.AIProcessorCgi/Process';
export const FaceBackEndUrl = 'https://ai.tu.qq.com/trpc.shadow_cv.face_stylize_cgi.FaceStylizeCgi/FaceDetectSimple';
function getUinHeaders() {
    const qqUin = getCookie('uin');
    if (!qqUin)
        return {};
    return {
        'x-uin': qqUin.slice(1)
    };
}
const fetchVideo = (apiUrl, data) => __awaiter(void 0, void 0, void 0, function* () {
    const { isForceProcess, images, cardType, coverIndex } = data;
    try {
        const reqBody = {
            busi_id: 'xmas_card',
            extra: JSON.stringify({
                cover_index: coverIndex,
                force_process: isForceProcess,
                card_type: cardType,
                cos_dir: 'test',
            }),
            images: [images],
        };
        // @ts-ignore
        const result = yield axios.post(apiUrl, reqBody, { headers: getUinHeaders() });
        return result.data;
    }
    catch (err) {
        console.log(err);
        return err;
    }
});
/**
 * 获取后台接口参数，动态字段 vision 可配置
 */
const getRequestParmas = (material, imgBase64, extraSpecial) => {
    let busiId = material.selectChildrenBusinessId || material.businessId;
    let extraParams = {};
    if (material.extraInfo) {
        const extra = JSON.parse(material.extraInfo)[busiId];
        busiId = extra.busiId;
        delete extra.busiId;
        extraParams = extra;
    }
    const requestInfo = {
        busiId,
        images: Array.isArray(imgBase64) ? imgBase64 : [imgBase64],
        extra: JSON.stringify(Object.assign(Object.assign(Object.assign({}, extraParams), extraSpecial), { platform: 'web', data_report: {
                parent_trace_id: currentTraceId,
                root_channel: getQueryParam('root_channel', ''),
                level: parseInt(getQueryParam('level', '0'), 10)
            } })),
    };
    return requestInfo;
};
export const getBackendResult = (material, imgBase64, backgroundUrl, extraSpecial) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return yield axios.post(backgroundUrl || BackEndUrl, getRequestParmas(material, imgBase64, extraSpecial), { headers: getUinHeaders() });
    }
    catch (e) {
        return e;
    }
});
/**
 * 获取人脸数量
 */
export const getFaceNumber = (base64, backgroundUrl) => __awaiter(void 0, void 0, void 0, function* () {
    return yield axios.post(backgroundUrl || BackEndUrl, {
        busiId: 'face_rect_detect',
        images: [base64],
    }, { headers: getUinHeaders() });
});
